import React from 'react'
import './DescriptionBox.css'

const DescriptionBox = () => {
  return (
    <div className='descriptionbox'>
      <div className="descriptionbox-navigator">
        <div className="descriptionbox-nav-box">Description</div>
        <div className="descriptionbox-nav-box fade">Reviews (122)</div>
      </div>
      <div className="descriptionbox-description">
        <p>Regular Fit Half Sleeve T-Shirt made of comfortable, Bio Washed fabric. Fabric Composition - 100% Cotton.
             Vintage Chest Print. Pattern - Printed Round Neck T-Shirt. Casual crew-neck styling. Men's Regular Fit 
             Polo Neck Half Sleeve Solid Casual T-shirt is a stylish and comfortable choice for casual wear.
              Elevate your casual wardrobe with this classic piece that effortlessly combines a timeless design
               with modern details. The half sleeves provide a balanced look, allowing you to stay cool in warmer 
               weather while still maintaining a polished appearance. The relaxed fit ensures ease of movement,
                making it an ideal choice for various activities, from weekend outings to casual workdays.
        </p>
        <p>
        T-shirt is a style of shirt that features a high, close-fitting collar that extends up the neck.
         The collar is designed to fold over and cover the neck, providing extra warmth and a stylish look.
          The unique feature of this T-shirt is the presence of a contrast layer. It is a standout choice for
           those who appreciate stylish details in their wardrobe.
        </p>
      </div>
    </div>
  )
}

export default DescriptionBox 
